import is from "is-type-of";

const trim = function (str) {
  if (String.prototype.trim) {
    return str.trim();
  } else {
    return str.replace(/^\s+|\s+$/g, "");
  }
};
/**
 * 补齐数字位数
 * @return {string}
 */
function getNumTwoBit(n) {
  n = Number(n);
  return (n > 9 ? "" : "0") + n;
}

/**
 * 时间戳转换为UTC日期格式
 * @return {String}
 */
function timestampUTC(date) {
  date = new Date(date);
  var timestamp = date.getTime() - 8 * 60 * 60 * 1000;
  date = new Date(timestamp);
  var dateStr = "";
  dateStr = `${date.getFullYear()}${getNumTwoBit(
    date.getMonth() + 1,
  )}${getNumTwoBit(date.getDate())}T${getNumTwoBit(
    date.getHours(),
  )}${getNumTwoBit(date.getMinutes())}${getNumTwoBit(date.getSeconds())}Z`;
  return dateStr;
}

/**
 * 检测是否是文件类型
 * @return {Boolean}
 */
function isFile(file) {
  return toString.call(file) === "[object File]";
}

function isBlob(file) {
  return toString.call(file) === "[object Blob]";
}
/**
 * 获取文件大小
 * @return {Boolean}
 */
function getFileSize(file) {
  if (is.buffer(file)) {
    return file.length;
  } else if (isFile(file) || isBlob(file)) {
    return file.size;
  }
  if (is.string(file)) {
    return file.length;
  }
  throw new Error("is Buffer/File/Blob/String type");
}

export { trim, timestampUTC, getFileSize };
